import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DashboardLayout from '../Layout/Index'
import CustomersTable from '../components/tables/CustomersTable'
import CustomerDrawer from '../Modals/CustomerDrawer'
import { FiSearch } from "react-icons/fi";
import { fetchCustomers } from '../redux/slices/CustomerSlice';
import { SelectDropDown } from '../components/SelectDropdown';

const Customers = () => {
  const itemsPerPage = 10;
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0); 
  const [categoryId, setCategoryId] = useState(null)

  const menu = useSelector((state) => state?.category);
  const customers = useSelector((state) => state?.customer);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() =>{
    dispatch(
      fetchCustomers({
      searchText: searchTerm,
      pageSize: itemsPerPage,
      pageNumber: currentPage,
      categoryId: categoryId,
    }))
  }, [dispatch, searchTerm, currentPage, categoryId]);

  useEffect(() => {
    if(customers){
      setTotalRecord(customers?.customers?.totalRecord);
    }
  },[customers]);

  const data = customers?.customers?.data;
  const categoryList = menu?.category?.data; 

  const SelectedOption = categoryList?.map((category) => ({
    label:category.name, value: category.id
  }))

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsDrawerOpen(true); 
  };

  const handleChange = (selectedOption) => {
    setCategoryId(selectedOption.value);
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 pt-5 py-10 bg-white w-full mt-16">
        <div className="bg-white px-2 py-3">
          <h1 className="text-2xl font-bold text-[#FF0000] pb-2">Customer Hub</h1>
          <p className="text-sm md:text-md text-[#0A0A0A]/80">
            Get to know your customers better—explore their order history, favorite dishes, and preferences. With filters, find details that help you make each experience memorable
          </p>
        </div>
        <div className="h-[1px] w-full border-0 bg-[#DADADA] my-2" />
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 px-4 py-6 bg-white">
          <div className="relative">
            <input
              type="search"
              name="search"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search by customer, phone number"
              className="bg-[#F9F9F9] px-12 py-3 rounded-2xl w-full md:w-[350px] ring-0 outline-none text-sm"
            />
            <FiSearch className="absolute left-4 top-3 text-lg text-[#A6A9B9]" />
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <p className="text-sm pr-2"> Food Category </p>
              {SelectedOption?.length > 0 && (
                <SelectDropDown
                  options={SelectedOption}
                  onSelect={handleChange}
                />
              )}
            </div>
          </div>
        </div>
        <CustomersTable 
          onRowClick={handleRowClick} 
          searchTerm={searchTerm} 
          data={data} 
          itemsPerPage={itemsPerPage} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={categoryList?.loading}
        />
        <CustomerDrawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          id={selectedItem}
        />
      </div>
    </DashboardLayout>
  )
}

export default Customers